import React, { useEffect, useMemo, useState } from "react";
import { FaArrowLeft, FaSpinner } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import useApp from "../../hooks/useAppContext";
import "../adm/admPatrocinadoresList.css";
import AreaPatrocinadores from "./areaPatrocinadores";
import "./patrocinadores.css";

/** Cotas e extras — regra de apresentação (não alterar sem alinhamento de negócio). */
const COTAS_APRESENTACAO = [
  { cota: "PREMIUM", id_cota: 1, id_extra: [] },
  { cota: "ADVANCE", id_cota: 3, id_extra: [] },
  // Lite (4) + Lite M (6) na mesma seção de apresentação
  { cota: "LITE", id_cota: [4, 6], id_extra: [] },
  {
    cota: "LOUNGE",
    id_cota: 8,
    id_extra: [36,37,21,23,24,25,26,28,22,30,31,20,32],
  },
  { cota: "RELACIONAMENTO", id_cota: 8, id_extra: [36,37,38,19,11,20,30,32] },
  { cota: "CONTEUDO", id_cota: 8, id_extra: [24] },
  {
    cota: "CAFETERIA",
    id_cota: 8,
    id_extra: [39,33,34,38,27,40],
  },
  { cota: "EXPERIÊNCIA", id_cota: 8, id_extra: [5,29,41] },
];

const Patrocinadores = () => {
  const navigate = useNavigate();
  const { getPatrocinadores } = useApp();
  const [patrocinadores, setPatrocinadores] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let ativo = true;

    const carregar = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const lista = await getPatrocinadores();
        if (!ativo) return;
        setPatrocinadores(Array.isArray(lista) ? lista : []);
      } catch (err) {
        console.error("Erro ao carregar patrocinadores:", err);
        if (!ativo) return;
        setError("Não foi possível carregar os patrocinadores.");
        setPatrocinadores([]);
      } finally {
        if (ativo) setIsLoading(false);
      }
    };

    carregar();
    return () => {
      ativo = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const totalComLogo = useMemo(() => {
    if (!Array.isArray(patrocinadores)) return 0;
    return patrocinadores.filter((p) => Boolean(p?.logo)).length;
  }, [patrocinadores]);

  return (
    <div className="main patrocinadores-page-bg">
      <div className="patrocinadores-page-overlay" aria-hidden />

      <div className="corpo-pagina patrocinadores-page">
        <div className="apl-page">
          <header
            className="apl-header"
            aria-label="Cabeçalho dos patrocinadores"
          >
            <div className="apl-header-text">
              <h1>Patrocinadores</h1>
              <p>
                Conheça as empresas que apoiam o evento.
              </p>
            </div>

            <div className="apl-toolbar apl-toolbar--inline">
              <button
                type="button"
                className="apl-btn apl-btn--ghost"
                onClick={() => navigate(-1)}
                title="Voltar"
              >
                <FaArrowLeft size={14} aria-hidden />
                Voltar
              </button>
            </div>
          </header>

          <div className="body-tela-adm" style={{ paddingBottom: 0 }}>
            {error ? (
              <div className="apl-alert" role="alert">
                {error}
              </div>
            ) : null}

            {isLoading ? (
              <div className="apl-loading" role="status" aria-live="polite">
                <FaSpinner className="fa-spin" size={28} aria-hidden />
                <span>Carregando patrocinadores…</span>
              </div>
            ) : (
              <section
                className="apl-card patrocinadores-lista-card"
                aria-label="Lista de patrocinadores por cota"
              >
                {totalComLogo === 0 ? (
                  <div className="apl-empty">
                    <p className="apl-empty-title">Nenhum patrocinador</p>
                    <p style={{ margin: 0 }}>
                      Quando houver marcas cadastradas com logo, elas aparecerão
                      aqui por cota.
                    </p>
                  </div>
                ) : (
                  <div className="patrocinadores-cotas">
                    {COTAS_APRESENTACAO.map((item) => (
                      <AreaPatrocinadores
                        key={item.cota}
                        patrocinadores={patrocinadores}
                        cota={item.cota}
                        id_cota={item.id_cota}
                        id_extra={item.id_extra}
                      />
                    ))}
                  </div>
                )}
              </section>
            )}
          </div>
        </div>
      </div>

      <div className="espaco-footer" aria-hidden />
    </div>
  );
};

export default Patrocinadores;
